import simpleFreeArenaTicket from './assets/simpleFreeArenaTicket.svg';
import simpleTicketClaimed from './assets/simpleTicketClaimed.svg';
import simpleTicketUnclaimed from './assets/simpleTicketUnclaimed.svg';

type Props = {
  variant?: 'claimed' | 'unclaimed';
  free?: boolean;
};
export const SimpleTicket = ({ variant = 'unclaimed', free }: Props) => {
  const arenaTicket =
    variant === 'unclaimed' ? simpleTicketUnclaimed : simpleTicketClaimed;
  return <img src={free ? simpleFreeArenaTicket : arenaTicket} alt="" />;
};
